import Modal from '../../components/ui/Modal';
import Button from '../../components/ui/Button';
import { Icon } from '../../components/ui/Icon';
import { TASK_TEMPLATES } from '../../constants/taskTemplates';

/**
 * TaskTemplatePicker — "Yeni Gorev" akisinin 1. adimi.
 *
 * Admin bos formla karsilasmak yerine once bir sablon secer. Secim sonrasi
 * parent (Tasks/index.jsx) TaskFormWizard'i ``initial={template.build()}``
 * ile acar — gorev tipine uygun default'lar hazirdir, admin sadece adi,
 * puan esiklerini ve hedef kitleyi gunceller.
 *
 * Props:
 *   open:       bool
 *   onClose:    () => void
 *   onPick:     (template) => void — template objesi (TASK_TEMPLATES'tan)
 */
export default function TaskTemplatePicker({ open, onClose, onPick }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Yeni Görev — Şablon Seçin"
      size="lg"
      footer={
        <Button variant="secondary" onClick={onClose}>
          İptal
        </Button>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-neutral-600">
          Görev türünü seçin. Seçtiğiniz şablon, görev tipine uygun ön
          ayarlarla form açılmasını sağlar — siz yalnızca görev adını, puan
          eşiklerini ve isterseniz müdürlük/segment kısıtını girersiniz.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
          {TASK_TEMPLATES.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => {
                onPick(t);
              }}
              className="group flex items-start gap-3 rounded-xl border border-neutral-200 bg-white p-4 text-left transition-all hover:border-primary-400 hover:bg-primary-50/30 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
            >
              <div
                className={`rounded-lg p-2 flex-shrink-0 ${
                  t.color === 'blue' ? 'bg-blue-100 text-blue-700'
                    : t.color === 'amber' ? 'bg-amber-100 text-amber-700'
                    : t.color === 'teal' ? 'bg-teal-100 text-teal-700'
                    : t.color === 'green' ? 'bg-green-100 text-green-700'
                    : t.color === 'sky' ? 'bg-sky-100 text-sky-700'
                    : t.color === 'pink' ? 'bg-pink-100 text-pink-700'
                    : 'bg-neutral-100 text-neutral-700'
                }`}
              >
                <Icon name={t.icon || 'tasks'} className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h4 className="font-semibold text-neutral-900 text-sm">{t.label}</h4>
                  {t.metric_label && (
                    <span className="text-[10px] uppercase tracking-wide text-neutral-500 bg-neutral-100 px-1.5 py-0.5 rounded">
                      {t.metric_label}
                    </span>
                  )}
                </div>
                <p className="text-xs text-neutral-600 mt-1 leading-relaxed">
                  {t.description}
                </p>
                {t.example && (
                  <p className="text-[11px] text-neutral-400 mt-1.5 italic">
                    {t.example}
                  </p>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
